import { Identifiable, List, Project } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { getProjectGantt } from "./getProjectGantt";
import { Linker } from "../linkers/types";

function findList(
  lists: Identifiable<List>[],
  list: Identifiable<List>,
): Identifiable<List> | null {
  return lists.reduce<Identifiable<List> | null>(
    (foundList, l) =>
      foundList || (l.uuid === list.uuid ? l : findList(l.subLists, list)),
    null,
  );
}

function duplicateList(httpClient: HttpClient, linker: Linker) {
  return (list: Identifiable<List>, rank: number) =>
    httpClient
      .sendHttpRequest<Identifiable<List>>({
        endpoint: `/activities/${list.uuid}/duplicate?keyRank=${rank}`,
        method: HttpMethods.POST,
      })
      .then((duplicatedList) => ({ ...list, ...duplicatedList }))
      .then((list) =>
        httpClient
          .sendHttpRequest<Identifiable<Project>>({
            endpoint: `/activities/${list.uuid}/project`,
            method: HttpMethods.GET,
          })
          .then((project) =>
            getProjectGantt(
              httpClient,
              linker,
            )(project).then((gantt) => ({ project, gantt })),
          )
          .then(({ gantt, project }) => {
            const p = gantt.projects.find(({ uuid }) => uuid === project.uuid);

            if (!p) {
              return Promise.reject();
            }

            const duplicatedList = findList(p.lists, list);

            return !!duplicatedList
              ? Promise.resolve(duplicatedList)
              : Promise.reject();
          }),
      );
}

export { duplicateList };
